import { Theme } from '@material-ui/core/styles';

type FontSizeByBreakpoint = { xs: number; sm?: number };

/** Fixed height for -webkit-line-clamp text (1 or 2 lines render at the same block height). */
export const clampedTextBlock = (
  theme: Theme,
  lines: 1 | 2,
  fontSizePx: FontSizeByBreakpoint,
) => {
  const smSize = fontSizePx.sm ?? fontSizePx.xs;
  return {
    display: '-webkit-box',
    WebkitLineClamp: lines,
    WebkitBoxOrient: 'vertical' as const,
    overflow: 'hidden',
    lineHeight: theme.typography.body1.lineHeight,
    fontSize: theme.typography.pxToRem(fontSizePx.xs),
    height: `calc(${theme.typography.pxToRem(fontSizePx.xs)} * ${
      theme.typography.body1.lineHeight
    } * ${lines})`,
    [theme.breakpoints.up('sm')]: {
      fontSize: theme.typography.pxToRem(smSize),
      height: `calc(${theme.typography.pxToRem(smSize)} * ${
        theme.typography.body1.lineHeight
      } * ${lines})`,
    },
  };
};
